export const SURFACE_EDITOR_THEME_KEY = Symbol('surface-editor-theme');

export function provideSurfaceEditorTheme({themeMode, isDark, setThemeMode, toggleThemeMode}) {
  provide(SURFACE_EDITOR_THEME_KEY, {
    themeMode,
    isDark,
    setThemeMode,
    toggleThemeMode
  });
}

export function useSurfaceEditorTheme() {
  const api = inject(SURFACE_EDITOR_THEME_KEY, null);

  if (!api) {
    throw new Error('useSurfaceEditorTheme() must be used inside a surface editor');
  }

  return api;
}
